module.exports = __webpack_public_path__ + "img/bg_print.b72032b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_print.jpg
// module id = AFwa
// module chunks = 172